const ths = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id'
  },
  {
    id: 2,
    label: 'First Name',
    intlKey: 'table.first_name'
  },
  {
    id: 3,
    label: 'Last Name',
    intlKey: 'table.last_name'
  },
  {
    id: 4,
    label: 'Activity Section',
    intlKey: 'table.activity_section'
  },
  {
    id: 5,
    label: 'Activity',
    intlKey: 'table.activity'
  },
  {
    id: 6,
    label: 'Invited By',
    intlKey: 'table.invited_by'
  },
  {
    id: 7,
    label: 'Organization',
    intlKey: 'table.organization',
    sortableId: 'assessor.organization.name'
  },
  {
    id: 8,
    label: 'Review',
    intlKey: 'table.review'
  },
  {
    id: 9,
    label: 'Action',
    intlKey: 'table.action'
  }
]

export default ths
